module.exports = __webpack_public_path__ + "static/media/vf_mpants_core.fbfe9f9f.svg";